import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import SmoothScroll from "@/components/SmoothScroll";
import RouteAnalytics from "@/components/RouteAnalytics";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import OurStory from "@/pages/OurStory";
import Team from "@/pages/Team";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Shop from "@/pages/Shop";
import Offers from "@/pages/Offers";
import Contact from "@/pages/Contact";
import FAQ from "@/pages/FAQ";
import BookNow from "@/pages/BookNow";
import NotFound from "@/pages/NotFound";
import { BUSINESS } from "@/data/content";

const origin = typeof window !== "undefined" ? window.location.origin : "";

const structuredData = {
  "@context": "https://schema.org",
  "@type": "BeautySalon",
  name: "Barrhaven Beauty Lounge",
  description:
    "Custom facials, laser hair removal, waxing, threading and advanced Korean skincare in Nepean, Ottawa.",
  image: `${origin}/og-image.jpg`,
  url: origin,
  telephone: BUSINESS.phoneDisplay,
  email: BUSINESS.email,
  address: {
    "@type": "PostalAddress",
    streetAddress: "80 Marketplace Ave",
    addressLocality: "Nepean",
    addressRegion: "ON",
    postalCode: "K2J 4H9",
    addressCountry: "CA",
  },
  priceRange: "$$",
  openingHours: [
    "Mo-We 11:00-18:00",
    "Th-Fr 11:00-19:00",
    "Sa 11:00-18:00",
  ],
};

function App() {
  return (
    <BrowserRouter>
      <Helmet>
        <html lang="en" />
        <meta name="theme-color" content="#050505" />
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>
      <SmoothScroll>
        <RouteAnalytics />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/our-story" element={<OurStory />} />
            <Route path="/team" element={<Team />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/offers" element={<Offers />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/book" element={<BookNow />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </SmoothScroll>
      <Toaster position="top-center" />
    </BrowserRouter>
  );
}

export default App;
